import 'css-chunksrc/client/pages/projectPage/synthesisPage/taskSection/toggleButton/styles.scss';export default {
  "toggleButton": "_toggleButton_8lhup_1",
  "button": "_button_8lhup_12",
  "dot": "_dot_8lhup_22",
  "active": "_active_8lhup_31",
  "left": "_left_8lhup_35",
  "right": "_right_8lhup_39"
};